import { Classroom } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    classrooms: [],
  },
  actions: {
    async fetch({ commit }, params) {
      try {
        commit('setClassroom', await Classroom.fetch(params))
      } catch (error) {
        alert.error(error)
      }
    },
    async create({ commit }, classroom) {
      try {
        const newClassroom = await Classroom.create(classroom)
        commit('addClassroom', newClassroom)
      } catch (error) {
        alert.error(error)
      }
    },
    async update({ commit }, { id, classroom }) {
      try {
        const updatedClassroom = await Classroom.update(id, classroom)
        commit('updateClassroom', updatedClassroom)
      } catch (error) {
        alert.error(error)
      }
    },
    async delete({ commit }, id) {
      try {
        await Classroom.remove(id)
        commit('deleteClassroom', id)
      } catch (error) {
        alert.error(error)
      }
    },
  },
  mutations: {
    setClassroom(state, classrooms) {
      state.classrooms = classrooms
    },
    addClassroom(state, classroom) {
      state.classrooms.push(classroom)
    },
    updateClassroom(state, updatedClassroom) {
      const index = state.classrooms.findIndex((c) => c.id === updatedClassroom.id)
      if (index !== -1) {
        state.classrooms.splice(index, 1, updatedClassroom)
      }
    },
    deleteClassroom(state, id) {
      state.classrooms = state.classrooms.filter((c) => c.id !== id)
    },
  },
}
